import { render, staticRenderFns } from "./PdpPopupV1.vue?vue&type=template&id=74d6ccd0&scoped=true"
import script from "./PdpPopupV1.vue?vue&type=script&lang=js"
export * from "./PdpPopupV1.vue?vue&type=script&lang=js"
import style0 from "./PdpPopupV1.vue?vue&type=style&index=0&id=74d6ccd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6ccd0",
  null
  
)

export default component.exports